import React, { FunctionComponent } from 'react';
import MeshHeader from '../../icons/MeshHeader/MeshHeader';
import { useRouteProps } from '../../redux/hooks/useRouteProps';

const Header: FunctionComponent = () => {
    const { headerSwitch } = useRouteProps();

    return <MeshHeader headerText={headerSwitch} />;
};

export default Header;
